import React from 'react';

interface StepHeaderProps {
  icon: string;
  title: string;
  description?: string;
}

/**
 * Gradient blue header used at the top of each signup step.
 * Provides a consistent look across ReviewSign, AustracDocuments, AgreementSign, etc.
 */
const StepHeader: React.FC<StepHeaderProps> = ({ icon, title, description }) => (
  <div style={{
    background: 'linear-gradient(135deg, #0F2647 0%, #1B3A6B 100%)',
    borderRadius: 14,
    padding: '26px 30px',
    marginBottom: 24,
    display: 'flex',
    alignItems: 'center',
    gap: 18,
  }}>
    <div style={{
      width: 52, height: 52, borderRadius: 14,
      background: 'rgba(255,255,255,0.12)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 26, flexShrink: 0,
    }}>{icon}</div>
    <div>
      <h2 style={{ margin: 0, color: '#fff', fontSize: 21, fontWeight: 700, letterSpacing: '-0.01em' }}>
        {title}
      </h2>
      {description && (
        <p style={{ margin: '5px 0 0', color: 'rgba(255,255,255,0.6)', fontSize: 13, lineHeight: 1.5 }}>
          {description}
        </p>
      )}
    </div>
  </div>
);

export default StepHeader;
